import { render, staticRenderFns } from "./AddChannelStage3.vue?vue&type=template&id=0761e461&scoped=true"
import script from "./AddChannelStage3.vue?vue&type=script&lang=js"
export * from "./AddChannelStage3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0761e461",
  null
  
)

export default component.exports